class WishlistPage extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    const grid = document.getElementById("mib-wishlist-grid");
    if (!grid) return;

    const SPINNER_HTML = `<div class="mib-wishlist-loading-spinner"><div class="mib-wishlist-spinner" aria-hidden="true"></div></div>`;

    const EMPTY_HTML = `<div class="mib-wishlist-empty-state">
        <p class="mib-wishlist-empty-state__title">${window.messages.wishlist_empty_heading}</p>
        <p class="mib-wishlist-empty-state__text">${window.messages.wishlist_empty_text}</p>
        <svg class="mib-wishlist-empty-state__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path fill="currentColor" d="M10.7608 18.2361L10 16.9431C10.7606 18.236 10.7614 18.2363 10.7617 18.2361V18.2351C10.7624 18.2347 10.7638 18.2347 10.7647 18.2341C10.7664 18.2331 10.7687 18.2309 10.7715 18.2292C10.777 18.226 10.7847 18.2221 10.794 18.2166C10.8128 18.2053 10.8395 18.1891 10.8731 18.1687C10.9401 18.1278 11.0355 18.0687 11.1553 17.9929C11.3949 17.8413 11.7329 17.6214 12.1358 17.3425C12.9389 16.7865 14.0151 15.9852 15.0908 15.0134C16.16 14.0476 17.2718 12.8756 18.1084 11.5691C18.94 10.2705 19.5718 8.72546 19.4932 7.05737C19.3592 4.21695 17.1582 1.52424 14.0264 1.49976C12.1317 1.48496 10.8254 2.4388 10 3.40601C9.17466 2.4388 7.8683 1.48496 5.97365 1.49976C2.84179 1.52424 0.640842 4.21695 0.506851 7.05737C0.428279 8.72546 1.06006 10.2705 1.89162 11.5691C2.72825 12.8756 3.84005 14.0476 4.9092 15.0134C5.98492 15.9852 7.0611 16.7865 7.86427 17.3425C8.26717 17.6214 8.60508 17.8413 8.84474 17.9929C8.96449 18.0687 9.05989 18.1278 9.12697 18.1687C9.1605 18.1891 9.18724 18.2053 9.20607 18.2166C9.21528 18.2221 9.22302 18.226 9.22853 18.2292C9.2313 18.2309 9.23358 18.2331 9.23537 18.2341C9.23626 18.2347 9.23766 18.2347 9.2383 18.2351V18.2361C9.23861 18.2363 9.2391 18.2358 9.76466 17.3425L9.23927 18.2361L10 18.6833L10.7608 18.2361ZM10 16.9431C9.99723 16.9415 1.77036 12.101 2.0049 7.12769C2.10512 5.00324 3.68658 3.1376 5.78127 3.00757L5.98537 2.99976C9.03742 2.97592 10 6.48608 10 6.48608C10 6.48608 10.9033 3.19189 13.7344 3.00757L14.0147 2.99976C16.1412 3.01638 17.7856 4.81661 17.9805 6.92261L17.9951 7.12769C18.2297 12.1018 10 16.9431 10 16.9431Z"/>
        </svg>
      </div>`;

    const ERROR_HTML = `<div class="mib-wishlist-empty-state mib-wishlist-empty-state--error">
      <svg class="mib-wishlist-empty-state__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      <p class="mib-wishlist-empty-state__title">${window.mibWishlistTranslations?.couldNotLoad ?? "Could not load wishlist"}</p>
      <p class="mib-wishlist-empty-state__text">${window.mibWishlistTranslations?.invalidLink ?? "The link may be invalid or expired. Try again later."}</p>
    </div>`;

    const itemKey = item => `${item?.productId ?? ""}|${item?.variantId ?? ""}`;

    let previousItemKeys = new Set();

    const esc = s => {
      const str = String(s ?? "");
      return str.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    };

    const showLoading = () => {
      grid.setAttribute("data-mib-wishlist-loading", "true");
      grid.innerHTML = SPINNER_HTML;
    };

    const formatPrice = item => {
      if (!item) return "";

      const amount = typeof item.price === "number" ? item.price : Number(item.price);

      if (Number.isNaN(amount)) return item.price ?? "";

      return new Intl.NumberFormat(undefined, { style: "currency", currency: item.currencyCode ?? "USD", maximumFractionDigits: 2 }).format(amount);
    };

    const getItems = source => {
      const list = source?.items;
      return Array.isArray(list) ? list : [];
    };

    const renderItems = list => {
      const items = Array.isArray(list) ? list : [];
      previousItemKeys = new Set(items.map(itemKey));
      if (items.length === 0) {
        grid.innerHTML = EMPTY_HTML;
        return;
      }
      grid.innerHTML = ``;
      grid.innerHTML += items
        .map(
          item => `
        <article class="mib-wishlist-card" role="listitem" data-mib-product-id="${esc(item.productId)}" data-mib-variant-id="${esc(item.variantId ?? "")}">
          <div class="product-card">
            <div class="product-card__media">
              <a class="product-card__media__inner" href="/products/${esc(item.productHandle)}">
                <img class="product-card__image" src="${esc(item.image)}" alt="${esc(item.productTitle)}" loading="lazy" />
              </a>
            </div>
            <a class="product-card__content" href="/products/${esc(item.productHandle)}">
              <div class="product-card__headline">
                <h3 class="product-card__title t-bold">${esc(item.productTitle)}</h3>
                <div class="product-card__price t-bold">
                  ${formatPrice(item)}
                </div>
              </div>
              ${item.variantTitle ? `<p class="product-card__variant-name t-xsmall">${esc(item.variantTitle)}</p>` : ""}
            </a>
          </div>
          <div class="product-card__actions mib-wishlist-card__actions">
            <button type="button" class="product-card__action-remove mib-wishlist-remove underline" data-mib-wishlist-remove data-mib-product-id="${esc(item.productId)}" data-mib-variant-id="${esc(item.variantId ?? "")}"><span>${window.messages.remove_from_wishlist}</span></button>
          </div>
        </article>
      `
        )
        .join("");

      handleAddToCart();
    };

    const apply = source => {
      const loading = source?.loading === true;
      grid.setAttribute("data-mib-wishlist-loading", loading ? "true" : "false");
      if (loading) {
        if (previousItemKeys.size === 0) grid.innerHTML = SPINNER_HTML;
        return;
      }
      const newItems = getItems(source);
      const newKeys = new Set(newItems.map(itemKey));
      const removedKey = previousItemKeys.size === newKeys.size + 1 && [...previousItemKeys].find(k => !newKeys.has(k));
      if (removedKey) {
        const cards = grid.querySelectorAll(".mib-wishlist-card");
        for (const card of cards) {
          const k = itemKey({ productId: card.getAttribute("data-mib-product-id"), variantId: card.getAttribute("data-mib-variant-id") });
          if (k === removedKey) {
            card.remove();
            previousItemKeys = newKeys;
            if (previousItemKeys.size === 0) grid.innerHTML = EMPTY_HTML;
            return;
          }
        }
      }
      renderItems(newItems);
    };

    const handleAddToCart = () => {
      const addToCartButtons = grid.querySelectorAll("[data-mib-wishlist-add-to-cart]");
      for (const btn of addToCartButtons) {
        btn.addEventListener("click", e => {
          e.preventDefault();
          document.dispatchEvent(new Event("theme:loading:start"));

          var item = {
            quantity: 1,
            id: btn.getAttribute("data-mib-variant-id") || btn.getAttribute("data-mib-product-id"),
            properties: {}
          };

          fetch(`${window.Shopify.routes.root}cart/add`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              items: [item]
            })
          }).then(() => {
            window.location.href = `${window.Shopify.routes.root}cart`;
          });
        });
      }
    };

    const runShareByCode = code => {
      const api = window.MIB_Wishlist?.getSharedWishlistByCode;
      if (typeof api !== "function") return false;
      showLoading();
      api(code)
        .then(data => {
          const el = document.getElementById("mib-wishlist-grid");
          if (!el) return;
          const fn = window.MIB_Wishlist_renderShareItems;
          if (data?.items?.length && fn) fn(data.items, el);
          else {
            el.removeAttribute("data-mib-wishlist-loading");
            el.innerHTML = EMPTY_HTML;
          }
        })
        .catch(() => {
          const el = document.getElementById("mib-wishlist-grid");
          if (el) {
            el.removeAttribute("data-mib-wishlist-loading");
            el.innerHTML = ERROR_HTML;
          }
        });
      return true;
    };

    const waitForMibWishlist = (code, maxMs) => {
      const start = Date.now();
      const tick = () => {
        if (runShareByCode(code)) return;
        if (Date.now() - start >= (maxMs ?? 8000)) {
          grid.removeAttribute("data-mib-wishlist-loading");
          grid.innerHTML = ERROR_HTML;
          return;
        }
        setTimeout(tick, 150);
      };
      tick();
    };

    grid.innerHTML = SPINNER_HTML;
    grid.setAttribute("data-mib-wishlist-loading", "true");

    // Track which button triggered the share
    let pendingShareButton = null;

    // Get share URL with code parameter
    const getShareUrl = shareCode => {
      const url = new URL(window.location.href);
      url.searchParams.set("share", shareCode);
      return url.toString();
    };

    // Show email share form modal
    const showEmailFormModal = shareUrl => {
      const existingModal = document.getElementById("mib-email-share-modal");
      if (existingModal) existingModal.remove();

      const modal = document.createElement("div");
      modal.id = "mib-email-share-modal";
      modal.innerHTML = `
        <div class="mib-share-modal-overlay"></div>
        <div class="mib-share-modal-content">
          <div class="mib-share-modal-header">
            <h2 class="h3">${window.mibWishlistTranslations?.sendToFriend ?? "Wyślij znajomemu"}</h2>
              <button class="mib-share-modal-close" type="button" aria-label="Close">
              <svg class="Icon Icon--close " viewBox="0 0 16.239 16.238">
                <g id="Path_607" data-name="Path 607" transform="translate(-66.835 -72.18)" fill="none">
                  <path d="M83.074,72.668l-.488-.488L74.955,79.81,67.324,72.18l-.488.488L74.466,80.3,66.836,87.93l.488.488,7.631-7.631,7.631,7.631.488-.488L75.443,80.3Z" stroke="none"></path>
                  <path d="M 67.32398986816406 72.17959594726562 L 74.95474243164062 79.81034088134766 L 82.58547973632812 72.17959594726562 L 83.073974609375 72.66806030273438 L 75.44319915771484 80.29880523681641 L 83.073974609375 87.92957305908203 L 82.58547973632812 88.41802978515625 L 74.95474243164062 80.78726959228516 L 67.32398986816406 88.41802978515625 L 66.83551025390625 87.92957305908203 L 74.46628570556641 80.29880523681641 L 66.83551025390625 72.66806030273438 L 67.32398986816406 72.17959594726562 Z" stroke="none" fill="#000"></path>
                </g>
              </svg>
            </button>
          </div>

          <div class="mib-share-modal-body">
            <form id="mib-share-form" class="mib-share-form">
              <div class="mib-share-form-row">
                <input type="text" id="mib-share-first-name" placeholder="${window.mibWishlistTranslations?.firstName ?? "Imię"}" class="mib-share-input" />
                <input type="text" id="mib-share-last-name" placeholder="${window.mibWishlistTranslations?.lastName ?? "Nazwisko"}" class="mib-share-input" />
              </div>
              <input type="email" id="mib-share-friend-email" placeholder="${window.mibWishlistTranslations?.friendEmail ?? "Email znajomego"}" required class="mib-share-input" />
              <textarea id="mib-share-message" placeholder="${window.mibWishlistTranslations?.message ?? "Wiadomość"}" class="mib-share-textarea"></textarea>
              <button type="submit" class="mib-share-submit-btn btn btn--primary">${window.mibWishlistTranslations?.send ?? "Wyślij"}</button>
            </form>
            <p class="mib-share-form-msg" style="display: none;"></p>
          </div>
        </div>
      `;

      document.body.appendChild(modal);

      // Close handlers
      modal.querySelector(".mib-share-modal-close").addEventListener("click", () => modal.remove());
      modal.querySelector(".mib-share-modal-overlay").addEventListener("click", () => modal.remove());

      // Form submission
      const form = modal.querySelector("#mib-share-form");
      const formMsg = modal.querySelector(".mib-share-form-msg");

      form.addEventListener("submit", async e => {
        e.preventDefault();

        const firstName = (document.getElementById("mib-share-first-name").value || "").trim();
        const lastName = (document.getElementById("mib-share-last-name").value || "").trim();
        const friendEmail = (document.getElementById("mib-share-friend-email").value || "").trim();
        const message = (document.getElementById("mib-share-message").value || "").trim();

        if (!friendEmail) return;

        const api = window.MIB_Wishlist && window.MIB_Wishlist.shareWishlistViaEmail;
        if (typeof api !== "function") return;

        const submitBtn = form.querySelector('button[type="submit"]');
        submitBtn.disabled = true;
        submitBtn.textContent = window.mibWishlistTranslations?.sending ?? "Wysyłanie...";

        try {
          const result = await api({ firstName, lastName, friendEmail, message });
          if (result && result.sent) {
            formMsg.textContent = window.mibWishlistTranslations?.sentSuccess ?? "✓ Wiadomość wysłana pomyślnie!";
            formMsg.className = "mib-share-form-msg mib-share-form-msg--success";
            formMsg.style.display = "block";
            form.reset();
            setTimeout(() => {
              modal.remove();
            }, 2000);
          } else {
            formMsg.textContent = window.mibWishlistTranslations?.sendError ?? "Błąd podczas wysyłania. Spróbuj ponownie.";
            formMsg.className = "mib-share-form-msg mib-share-form-msg--error";
            formMsg.style.display = "block";
          }
        } catch (err) {
          formMsg.textContent = (window.mibWishlistTranslations?.errorPrefix ?? "Błąd: ") + (err.message ?? window.mibWishlistTranslations?.unknownError);
          formMsg.className = "mib-share-form-msg mib-share-form-msg--error";
          formMsg.style.display = "block";
        } finally {
          submitBtn.disabled = false;
          submitBtn.textContent = window.mibWishlistTranslations?.send ?? "Wyślij";
        }
      });
    };

    // Get centered window position
    const getCenteredWindowPosition = (width, height) => {
      const left = (screen.width - width) / 2;
      const top = (screen.height - height) / 2;
      return `left=${left},top=${top}`;
    };

    // Handle share actions based on button type
    const handleShareAction = (shareCode, button) => {
      const shareUrl = getShareUrl(shareCode);

      if (button.hasAttribute("data-share-email")) {
        showEmailFormModal(shareUrl);
      } else if (button.hasAttribute("data-share-copy")) {
        navigator.clipboard.writeText(shareUrl).then(() => {
          const originalContent = button.innerHTML;
          button.innerHTML = window.mibWishlistTranslations?.copied ?? "✓ Skopiowano!";
          button.setAttribute("aria-busy", "false");
          setTimeout(() => {
            button.innerHTML = originalContent;
          }, 2000);
        });
      } else if (button.hasAttribute("data-share-facebook")) {
        const facebookFeatures = `width=626,height=436,${getCenteredWindowPosition(626, 436)}`;
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, "facebook-share-dialog", facebookFeatures);
        button.setAttribute("aria-busy", "false");
      } else if (button.hasAttribute("data-share-twitter")) {
        const twitterFeatures = `width=550,height=420,${getCenteredWindowPosition(550, 420)}`;
        window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(window.mibWishlistTranslations?.twitterShareText ?? "Check out my wishlist!")}`, "twitter-share", twitterFeatures);
        button.setAttribute("aria-busy", "false");
      } else if (button.hasAttribute("data-share-pinterest")) {
        const pinterestFeatures = `width=750,height=500,${getCenteredWindowPosition(750, 500)}`;
        window.open(`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(shareUrl)}`, "pinterest-share", pinterestFeatures);
        button.setAttribute("aria-busy", "false");
      }
    };

    // Initialize share buttons
    const initShareButtons = () => {
      const shareButtons = document.querySelectorAll("[data-mib-wishlist-share]");
      for (const btn of shareButtons) {
        btn.addEventListener("click", e => {
          e.preventDefault();
          btn.setAttribute("aria-busy", "true");
          pendingShareButton = btn;
        });
      }
    };

    window.addEventListener("mib:wishlist:items", e => apply(e?.detail));
    window.addEventListener("mib:wishlist:share-ready", e => {
      const { shareCode } = e.detail;
      if (shareCode && pendingShareButton) {
        handleShareAction(shareCode, pendingShareButton);
        pendingShareButton = null;
      }
    });

    const MIN_SPINNER_MS = 400;
    const spinnerShownAt = Date.now();

    const codeFromUrl = new URLSearchParams(location.search).get("share")?.trim();
    if (codeFromUrl) {
      window.MIB_Wishlist_renderShareItems = renderItems;
      document.querySelector(".mib-wishlist-share").style.display = "none";
      showLoading();
      if (!runShareByCode(codeFromUrl)) waitForMibWishlist(codeFromUrl);
    } else {
      grid.innerHTML = EMPTY_HTML;
      requestAnimationFrame(() => {
        const elapsed = Date.now() - spinnerShownAt;
        const wait = Math.max(0, MIN_SPINNER_MS - elapsed);
        const run = () => {
          const snapshot = window.MIB_Wishlist?.getSnapshot?.();
          if (snapshot != null) apply(snapshot);
        };
        if (wait > 0) setTimeout(run, wait);
        else run();
      });
    }

    // Initialize share buttons
    initShareButtons();
  }

  connectedCallback() {
    this.init();
  }
}

if (!customElements.get("wishlist-page")) customElements.define("wishlist-page", WishlistPage);
